<button
  type="button"
  class="btn pl-3 color-knbr-primary pr-3 mr-2 pb-2 pt-2 font-size-17 color-white h-auto hover-link"
>
  {{ 'common.save' | cxTranslate }}
</button>
